import drugs from "../../assets/icons/Icon_Drugs.svg";
import biologics from "../../assets/icons/Icon_Biology.svg"
import medical from "../../assets/icons/Icon_Medical_Devices.svg"
import cosmetics from "../../assets/icons/Icon_Cosmetics.svg"
import food from "../../assets/icons/Icon_Food_and_Nutraceuticals.svg"
import covid from "../../assets/icons/Icon_Covid_Essentials.svg"


const markets = [
  { label: 'Drugs', imgSrc: drugs },
  { label: 'Biologics', imgSrc: biologics },
  { label: 'Medical Devices', imgSrc: medical },
  { label: 'Cosmetics', imgSrc: cosmetics },
  { label: 'Food and Nutraceuticals', imgSrc: food },
  { label: 'Covid Essentials', imgSrc: covid },
];

const MarketsWeSupport = () => {
  return (
    <div className="bg-[#FFFFFF] py-12 text-center">
      <div className="relative inline-block mb-6 text-[#05326D] max-w-[var(--max-width)] mx-auto">
        <h1 className="inline-block relative text-3xl md:text-4xl text-[#05326D] mb-4 font-normal text-[32px]">
          Markets We Support
          <span className="absolute right-0 -bottom-2 w-[40px] border-b-[6px] border-[#B5AB28] rounded-[6px]"></span>
        </h1>
      </div>

      <p className="text-[#05326D] max-w-[var(--max-width)] mx-auto px-4">
        End-to-end expertise across pharmaceuticals, healthcare, and consumer wellness.
        <br />
        Our tailored solutions drive safety, innovation, and regulatory excellence.
      </p>

      <div className="max-w-[var(--max-width)] mx-auto mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 px-4 sm:px-12">
        {markets.map((market, index) => (
          <div key={index} className="flex flex-col items-center">
            <img
              src={market.imgSrc}
              alt={market.label}
              className="w-10 h-15 mb-2"
            />
            <p className="text-base font-bold text-[#05326D] text-center">
              {market.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketsWeSupport;
